import { LoginService } from 'services/LoginService'


const validateEmail = (email: string) => {
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]+\.[a-zA-Z]+$/
    return regex.test(email)
}


const hashText = async (password: string) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
};

const handleHash = async (password: string) => {
    const hash = await hashText(password);
    return hash;
};

const validatePassword = (value: string, setError: (error: boolean) => void, setHelperText: (text: string) => void) => {
    // Ejemplo de validaciones comunes
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumbers = /\d/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    if (value.length < minLength) {
        setError(true);
        setHelperText('La contraseña debe tener al menos 8 caracteres');
        return;
    }

    switch (true) {
        case !hasUpperCase:
            setError(true);
            setHelperText('La contraseña debe tener al menos una letra mayúscula');
            return;
        case !hasLowerCase:
            setError(true);
            setHelperText('La contraseña debe tener al menos una letra minúscula');
            return;
        case !hasNumbers:
            setError(true);
            setHelperText('La contraseña debe tener al menos un número');
            return;
        case !hasSpecialChar:
            setError(true);
            setHelperText('La contraseña debe tener al menos un caracter especial');
            return;
        default:
            break;
    }

    setError(false);
    setHelperText('');

}

const loginService = new LoginService()

const executeLogin = async (
    email: string,
    password: string,
    opt?: string
) => {
    return loginService.login(email, password, opt)
}

const logout = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>
) => {
    setLoading(true)

    const refreshToken = localStorage.getItem('refresh_token')
    if (refreshToken) {
        try {
            const body = new URLSearchParams()
            body.append('token', refreshToken)
            body.append('token_type_hint', 'refresh_token')
            await fetch(`${process.env.REACT_APP_TK_GW_DOMAIN}/v1/auth/v1/revoke`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body.toString(),
            })
        } catch (err) {
            console.error('No se pudo revocar el refresh token', err)
        }
    }

    new Promise((resolve) => {
        setTimeout(() => {
            resolve({ data: {} });
        }, 1000);
    })
        .then((response) => {
            localStorage.removeItem('access_token')
            localStorage.removeItem('token_type')
            localStorage.removeItem('expires_in')
            localStorage.removeItem('expires_at')
            localStorage.removeItem('refresh_token')
            localStorage.removeItem('refresh_expires_in')
            localStorage.removeItem('refresh_expires_at')
            sessionStorage.removeItem('authenticated')
            setAuthenticated(false)
        })
        .catch((error) => { console.error(error) })
        .finally(() => { setLoading(false) })

}

export {
    validateEmail,
    validatePassword,
    executeLogin,
    logout,
    handleHash
}